import React, { FC } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import PublicIcon from '@mui/icons-material/Public';
import { useTranslation } from 'react-i18next';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';

interface OvProductPlatformSelectorProps {
  platform?: 'web' | 'mobile';
  onSelect: (platform: 'web' | 'mobile') => void;
}

const OvProductPlatformSelector: FC<OvProductPlatformSelectorProps> = ({
  platform,
  onSelect,
}) => {
  const { t } = useTranslation();
  const iconStyle = { width: '2rem', height: '2rem' };

  return (
    <Container>
      <Option
        selected={platform === 'web'}
        onClick={(e) => {
          e.preventDefault();
          onSelect('web');
        }}
      >
        <PublicIcon style={iconStyle} />
        <OptionLabel>{t('physicalProducts.dialogs.platform.web')}</OptionLabel>
      </Option>

      <Option
        selected={platform === 'mobile'}
        onClick={(e) => {
          e.preventDefault();
          onSelect('mobile');
        }}
      >
        <PhoneAndroidIcon style={iconStyle} />
        <OptionLabel>
          {t('physicalProducts.dialogs.platform.mobile')}
        </OptionLabel>
      </Option>
    </Container>
  );
};

export default OvProductPlatformSelector;

const Container = styled.div`
  display: flex;
  gap: 1rem;
`;

const Option = styled.button<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 1rem;
  border: 2px solid transparent;
  background-color: ${({ selected }) =>
    selected ? Colours.OV_YELLOW : 'transparent'};
  border-radius: 1rem;
  transition: border-color 0.3s;
  flex-basis: 7rem;

  &:hover {
    border-color: ${Colours.OV_YELLOW};
  }
`;

const OptionLabel = styled.span`
  margin-top: 0.5rem;
  font-size: 0.875rem;
  text-align: center;
`;
